import { Dispatch } from 'redux';
import { ApiError, postRequest } from 'src/store/api-handler';
import { ImportProductDto } from './import';

export enum ImportTypes {
  SetImportProducts = 'imports/SetImportProducts',
  Failure = 'imports/Failure'
}

export type ImportAction =
  | {
      type: ImportTypes.SetImportProducts;
      importProducts: ImportProductDto[] | null;
    }
  | { type: ImportTypes.Failure; errors: ApiError };

export const importActions = {
  setImportProducts: (
    importProducts: ImportProductDto[] | null
  ): ImportAction => ({
    type: ImportTypes.SetImportProducts,
    importProducts
  }),
  requestFailure: (errors: ApiError): ImportAction => ({
    type: ImportTypes.Failure,
    errors
  })
};

export const parseGDMSAnalyzes = (files: File[]) => {
  const formData = new FormData();
  formData.append('file', files[0]);
  return async (dispatch: Dispatch) => {
    const { ok, data, error } = await postRequest<ImportProductDto[]>(
      'imports/gdms/parse',
      formData,
      true
    );
    if (ok) {
      return dispatch(importActions.setImportProducts(data));
    }
    return dispatch(importActions.requestFailure(error!));
  };
};

export const parseEurofinsAnalyzes = (files: File[]) => {
  const formData = new FormData();
  formData.append('file', files[0]);
  return async (dispatch: Dispatch) => {
    const { ok, data, error } = await postRequest<ImportProductDto[]>(
      'imports/eurofins/parse',
      formData,
      true
    );
    if (ok) {
      return dispatch(importActions.setImportProducts(data));
    }
    return dispatch(importActions.requestFailure(error!));
  };
};

export const parseCamsizerAnalyzes = () => {
  return async (dispatch: Dispatch) => {
    const { ok, data, error } = await postRequest<ImportProductDto[]>(
      'imports/camsizer/parse'
    );
    if (ok) {
      return dispatch(importActions.setImportProducts(data));
    }
    return dispatch(importActions.requestFailure(error!));
  };
};

export const parseNorlabAnalyzes = () => {
  return async (dispatch: Dispatch) => {
    const { ok, data, error } = await postRequest<ImportProductDto[]>(
      'imports/norlab/parse'
    );
    if (ok) {
      return dispatch(importActions.setImportProducts(data));
    }
    return dispatch(importActions.requestFailure(error!));
  };
};
